var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRocket = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 103,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 205 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 102C1.125 46.0812 46.4562 0.75 102.375 0.75C158.294 0.75 203.625 46.0812 203.625 102H1.125Z",
    fill: "#F4F6F8",
    stroke: "#F4F6F8",
    strokeWidth: 1.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5658 39.9721C59.5658 40.6775 60.0962 41.25 60.7497 41.25C61.4039 41.25 61.9342 40.6775 61.9342 39.9721V37.9342H63.9719C64.6774 37.9342 65.25 37.4037 65.25 36.75C65.25 36.0957 64.6774 35.5658 63.9719 35.5658H61.9342V33.5286C61.9342 32.8225 61.4039 32.25 60.7497 32.25C60.0962 32.25 59.5658 32.8225 59.5658 33.5286V35.5658H57.5281C56.8226 35.5658 56.25 36.0957 56.25 36.75C56.25 37.4037 56.8226 37.9342 57.5281 37.9342H59.5658V39.9721Z",
    fill: "#CAD0D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.066 51.2221C136.066 51.9275 136.596 52.5 137.25 52.5C137.904 52.5 138.434 51.9275 138.434 51.2221V49.1842H140.472C141.177 49.1842 141.75 48.6537 141.75 48C141.75 47.3457 141.177 46.8158 140.472 46.8158H138.434V44.7786C138.434 44.0725 137.904 43.5 137.25 43.5C136.596 43.5 136.066 44.0725 136.066 44.7786V46.8158H134.028C133.323 46.8158 132.75 47.3457 132.75 48C132.75 48.6537 133.323 49.1842 134.028 49.1842H136.066V51.2221Z",
    fill: "#CAD0D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.816 92.8471C169.816 93.5525 170.346 94.125 171 94.125C171.654 94.125 172.184 93.5525 172.184 92.8471V90.8092H174.222C174.927 90.8092 175.5 90.2787 175.5 89.625C175.5 88.9707 174.927 88.4408 174.222 88.4408H172.184V86.4036C172.184 85.6975 171.654 85.125 171 85.125C170.346 85.125 169.816 85.6975 169.816 86.4036V88.4408H167.778C167.073 88.4408 166.5 88.9707 166.5 89.625C166.5 90.2787 167.073 90.8092 167.778 90.8092H169.816V92.8471Z",
    fill: "#CAD0D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6875 78.375C38.6195 78.375 39.375 77.6195 39.375 76.6875C39.375 75.7555 38.6195 75 37.6875 75C36.7555 75 36 75.7555 36 76.6875C36 77.6195 36.7555 78.375 37.6875 78.375Z",
    fill: "#CAD0D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9375 64.875C58.8695 64.875 59.625 64.1195 59.625 63.1875C59.625 62.2555 58.8695 61.5 57.9375 61.5C57.0055 61.5 56.25 62.2555 56.25 63.1875C56.25 64.1195 57.0055 64.875 57.9375 64.875Z",
    fill: "#CAD0D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.938 36.75C157.869 36.75 158.625 35.9945 158.625 35.0625C158.625 34.1305 157.869 33.375 156.938 33.375C156.006 33.375 155.25 34.1305 155.25 35.0625C155.25 35.9945 156.006 36.75 156.938 36.75Z",
    fill: "#CAD0D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6875 41.25C38.6195 41.25 39.375 40.4945 39.375 39.5625C39.375 38.6305 38.6195 37.875 37.6875 37.875C36.7555 37.875 36 38.6305 36 39.5625C36 40.4945 36.7555 41.25 37.6875 41.25Z",
    fill: "#CAD0D8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1875 94.125C16.1195 94.125 16.875 93.3695 16.875 92.4375C16.875 91.5055 16.1195 90.75 15.1875 90.75C14.2555 90.75 13.5 91.5055 13.5 92.4375C13.5 93.3695 14.2555 94.125 15.1875 94.125Z",
    fill: "#CAD0D8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4375 19.875C99.3695 19.875 100.125 19.1195 100.125 18.1875C100.125 17.2555 99.3695 16.5 98.4375 16.5C97.5055 16.5 96.75 17.2555 96.75 18.1875C96.75 19.1195 97.5055 19.875 98.4375 19.875Z",
    fill: "#CAD0D8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1875 42.375C88.1195 42.375 88.875 41.6195 88.875 40.6875C88.875 39.7555 88.1195 39 87.1875 39C86.2555 39 85.5 39.7555 85.5 40.6875C85.5 41.6195 86.2555 42.375 87.1875 42.375Z",
    fill: "#CAD0D8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.062 21C140.994 21 141.75 20.2445 141.75 19.3125C141.75 18.3805 140.994 17.625 140.062 17.625C139.131 17.625 138.375 18.3805 138.375 19.3125C138.375 20.2445 139.131 21 140.062 21Z",
    fill: "#CAD0D8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.312 55.875C170.244 55.875 171 55.1195 171 54.1875C171 53.2555 170.244 52.5 169.312 52.5C168.381 52.5 167.625 53.2555 167.625 54.1875C167.625 55.1195 168.381 55.875 169.312 55.875Z",
    fill: "#CAD0D8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.438 80.625C189.369 80.625 190.125 79.8695 190.125 78.9375C190.125 78.0055 189.369 77.25 188.438 77.25C187.506 77.25 186.75 78.0055 186.75 78.9375C186.75 79.8695 187.506 80.625 188.438 80.625Z",
    fill: "#CAD0D8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.562 90.75C145.494 90.75 146.25 89.9945 146.25 89.0625C146.25 88.1305 145.494 87.375 144.562 87.375C143.631 87.375 142.875 88.1305 142.875 89.0625C142.875 89.9945 143.631 90.75 144.562 90.75Z",
    fill: "#CAD0D8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.438 33.375C117.991 33.375 119.25 32.1158 119.25 30.5625C119.25 29.0092 117.991 27.75 116.438 27.75C114.884 27.75 113.625 29.0092 113.625 30.5625C113.625 32.1158 114.884 33.375 116.438 33.375Z",
    fill: "#CAD0D8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.438 31.6875C117.059 31.6875 117.562 31.1838 117.562 30.5625C117.562 29.9412 117.059 29.4375 116.438 29.4375C115.816 29.4375 115.312 29.9412 115.312 30.5625C115.312 31.1838 115.816 31.6875 116.438 31.6875Z",
    fill: "#F4F6F8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9375 19.875C77.4908 19.875 78.75 18.6158 78.75 17.0625C78.75 15.5092 77.4908 14.25 75.9375 14.25C74.3842 14.25 73.125 15.5092 73.125 17.0625C73.125 18.6158 74.3842 19.875 75.9375 19.875Z",
    fill: "#CAD0D8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9375 18.1875C76.5588 18.1875 77.0625 17.6838 77.0625 17.0625C77.0625 16.4412 76.5588 15.9375 75.9375 15.9375C75.3162 15.9375 74.8125 16.4412 74.8125 17.0625C74.8125 17.6838 75.3162 18.1875 75.9375 18.1875Z",
    fill: "#F4F6F8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.438 71.625C153.991 71.625 155.25 70.3658 155.25 68.8125C155.25 67.2592 153.991 66 152.438 66C150.884 66 149.625 67.2592 149.625 68.8125C149.625 70.3658 150.884 71.625 152.438 71.625Z",
    fill: "#CAD0D8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.438 69.9375C153.059 69.9375 153.562 69.4338 153.562 68.8125C153.562 68.1912 153.059 67.6875 152.438 67.6875C151.816 67.6875 151.312 68.1912 151.312 68.8125C151.312 69.4338 151.816 69.9375 152.438 69.9375Z",
    fill: "#F4F6F8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8125 90.75C58.3658 90.75 59.625 89.4908 59.625 87.9375C59.625 86.3842 58.3658 85.125 56.8125 85.125C55.2592 85.125 54 86.3842 54 87.9375C54 89.4908 55.2592 90.75 56.8125 90.75Z",
    fill: "#CAD0D8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8125 89.0625C57.4338 89.0625 57.9375 88.5588 57.9375 87.9375C57.9375 87.3162 57.4338 86.8125 56.8125 86.8125C56.1912 86.8125 55.6875 87.3162 55.6875 87.9375C55.6875 88.5588 56.1912 89.0625 56.8125 89.0625Z",
    fill: "#F4F6F8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4375 64.875C27.9908 64.875 29.25 63.6158 29.25 62.0625C29.25 60.5092 27.9908 59.25 26.4375 59.25C24.8842 59.25 23.625 60.5092 23.625 62.0625C23.625 63.6158 24.8842 64.875 26.4375 64.875Z",
    fill: "#CAD0D8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4375 63.1875C27.0588 63.1875 27.5625 62.6838 27.5625 62.0625C27.5625 61.4412 27.0588 60.9375 26.4375 60.9375C25.8162 60.9375 25.3125 61.4412 25.3125 62.0625C25.3125 62.6838 25.8162 63.1875 26.4375 63.1875Z",
    fill: "#F4F6F8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.28 46.875L120.424 47.415C116.615 47.838 113.065 49.5458 110.356 52.2548L88.29 74.3205L97.83 83.865L119.9 61.7992C122.611 59.0902 124.317 55.5397 124.74 51.7305L125.28 46.875Z",
    stroke: "#464646",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.29 74.3205L80.1405 71.6025C79.2563 71.31 78.7793 70.356 79.0718 69.4717C79.155 69.222 79.2945 68.997 79.4813 68.8102L80.0033 68.2882C83.619 64.6725 88.9673 63.408 93.8183 65.0257L96.642 65.9662L88.29 74.3205Z",
    stroke: "#464646",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.29 74.3205L80.1405 71.6025C79.2563 71.31 78.7793 70.356 79.0718 69.4717C79.155 69.222 79.2945 68.997 79.4813 68.8102L80.0033 68.2882C83.619 64.6725 88.9673 63.408 93.8183 65.0257L96.642 65.9662L88.29 74.3205Z",
    fill: "#74B0F4",
    stroke: "#464646",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.83 83.865L100.548 92.0145C100.841 92.8987 101.795 93.3757 102.679 93.0832C102.929 93 103.156 92.8605 103.34 92.6737L103.865 92.1517C107.48 88.536 108.743 83.1877 107.125 78.3367L106.189 75.5242L97.83 83.865Z",
    stroke: "#464646",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.83 83.865L100.548 92.0145C100.841 92.8987 101.795 93.3757 102.679 93.0832C102.929 93 103.156 92.8605 103.34 92.6737L103.865 92.1517C107.48 88.536 108.743 83.1877 107.125 78.3367L106.189 75.5242L97.83 83.865Z",
    fill: "#74B0F4",
    stroke: "#464646",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1578 85.0598C92.16 86.403 91.6267 87.69 90.675 88.6395C88.6995 90.615 78.75 93.4118 78.75 93.4118C78.75 93.4118 81.5468 83.4555 83.5223 81.4868C84.3907 80.616 85.545 80.094 86.7712 80.013L92.1578 85.0598Z",
    fill: "#F18686",
    stroke: "#464646",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 103,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 205 103",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.125 102C1.125 46.0812 46.4562 0.75 102.375 0.75C158.294 0.75 203.625 46.0812 203.625 102H1.125Z",
    fill: "#F4F6F8",
    stroke: "#F4F6F8",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5658 39.9721C59.5658 40.6775 60.0962 41.25 60.7497 41.25C61.4039 41.25 61.9342 40.6775 61.9342 39.9721V37.9342H63.9719C64.6774 37.9342 65.25 37.4037 65.25 36.75C65.25 36.0957 64.6774 35.5658 63.9719 35.5658H61.9342V33.5286C61.9342 32.8225 61.4039 32.25 60.7497 32.25C60.0962 32.25 59.5658 32.8225 59.5658 33.5286V35.5658H57.5281C56.8226 35.5658 56.25 36.0957 56.25 36.75C56.25 37.4037 56.8226 37.9342 57.5281 37.9342H59.5658V39.9721Z",
    fill: "#CAD0D8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.066 51.2221C136.066 51.9275 136.596 52.5 137.25 52.5C137.904 52.5 138.434 51.9275 138.434 51.2221V49.1842H140.472C141.177 49.1842 141.75 48.6537 141.75 48C141.75 47.3457 141.177 46.8158 140.472 46.8158H138.434V44.7786C138.434 44.0725 137.904 43.5 137.25 43.5C136.596 43.5 136.066 44.0725 136.066 44.7786V46.8158H134.028C133.323 46.8158 132.75 47.3457 132.75 48C132.75 48.6537 133.323 49.1842 134.028 49.1842H136.066V51.2221Z",
    fill: "#CAD0D8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.816 92.8471C169.816 93.5525 170.346 94.125 171 94.125C171.654 94.125 172.184 93.5525 172.184 92.8471V90.8092H174.222C174.927 90.8092 175.5 90.2787 175.5 89.625C175.5 88.9707 174.927 88.4408 174.222 88.4408H172.184V86.4036C172.184 85.6975 171.654 85.125 171 85.125C170.346 85.125 169.816 85.6975 169.816 86.4036V88.4408H167.778C167.073 88.4408 166.5 88.9707 166.5 89.625C166.5 90.2787 167.073 90.8092 167.778 90.8092H169.816V92.8471Z",
    fill: "#CAD0D8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6875 78.375C38.6195 78.375 39.375 77.6195 39.375 76.6875C39.375 75.7555 38.6195 75 37.6875 75C36.7555 75 36 75.7555 36 76.6875C36 77.6195 36.7555 78.375 37.6875 78.375Z",
    fill: "#CAD0D8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9375 64.875C58.8695 64.875 59.625 64.1195 59.625 63.1875C59.625 62.2555 58.8695 61.5 57.9375 61.5C57.0055 61.5 56.25 62.2555 56.25 63.1875C56.25 64.1195 57.0055 64.875 57.9375 64.875Z",
    fill: "#CAD0D8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.938 36.75C157.869 36.75 158.625 35.9945 158.625 35.0625C158.625 34.1305 157.869 33.375 156.938 33.375C156.006 33.375 155.25 34.1305 155.25 35.0625C155.25 35.9945 156.006 36.75 156.938 36.75Z",
    fill: "#CAD0D8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6875 41.25C38.6195 41.25 39.375 40.4945 39.375 39.5625C39.375 38.6305 38.6195 37.875 37.6875 37.875C36.7555 37.875 36 38.6305 36 39.5625C36 40.4945 36.7555 41.25 37.6875 41.25Z",
    fill: "#CAD0D8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1875 94.125C16.1195 94.125 16.875 93.3695 16.875 92.4375C16.875 91.5055 16.1195 90.75 15.1875 90.75C14.2555 90.75 13.5 91.5055 13.5 92.4375C13.5 93.3695 14.2555 94.125 15.1875 94.125Z",
    fill: "#CAD0D8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4375 19.875C99.3695 19.875 100.125 19.1195 100.125 18.1875C100.125 17.2555 99.3695 16.5 98.4375 16.5C97.5055 16.5 96.75 17.2555 96.75 18.1875C96.75 19.1195 97.5055 19.875 98.4375 19.875Z",
    fill: "#CAD0D8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1875 42.375C88.1195 42.375 88.875 41.6195 88.875 40.6875C88.875 39.7555 88.1195 39 87.1875 39C86.2555 39 85.5 39.7555 85.5 40.6875C85.5 41.6195 86.2555 42.375 87.1875 42.375Z",
    fill: "#CAD0D8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.062 21C140.994 21 141.75 20.2445 141.75 19.3125C141.75 18.3805 140.994 17.625 140.062 17.625C139.131 17.625 138.375 18.3805 138.375 19.3125C138.375 20.2445 139.131 21 140.062 21Z",
    fill: "#CAD0D8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.312 55.875C170.244 55.875 171 55.1195 171 54.1875C171 53.2555 170.244 52.5 169.312 52.5C168.381 52.5 167.625 53.2555 167.625 54.1875C167.625 55.1195 168.381 55.875 169.312 55.875Z",
    fill: "#CAD0D8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.438 80.625C189.369 80.625 190.125 79.8695 190.125 78.9375C190.125 78.0055 189.369 77.25 188.438 77.25C187.506 77.25 186.75 78.0055 186.75 78.9375C186.75 79.8695 187.506 80.625 188.438 80.625Z",
    fill: "#CAD0D8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.562 90.75C145.494 90.75 146.25 89.9945 146.25 89.0625C146.25 88.1305 145.494 87.375 144.562 87.375C143.631 87.375 142.875 88.1305 142.875 89.0625C142.875 89.9945 143.631 90.75 144.562 90.75Z",
    fill: "#CAD0D8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.438 33.375C117.991 33.375 119.25 32.1158 119.25 30.5625C119.25 29.0092 117.991 27.75 116.438 27.75C114.884 27.75 113.625 29.0092 113.625 30.5625C113.625 32.1158 114.884 33.375 116.438 33.375Z",
    fill: "#CAD0D8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.438 31.6875C117.059 31.6875 117.562 31.1838 117.562 30.5625C117.562 29.9412 117.059 29.4375 116.438 29.4375C115.816 29.4375 115.312 29.9412 115.312 30.5625C115.312 31.1838 115.816 31.6875 116.438 31.6875Z",
    fill: "#F4F6F8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9375 19.875C77.4908 19.875 78.75 18.6158 78.75 17.0625C78.75 15.5092 77.4908 14.25 75.9375 14.25C74.3842 14.25 73.125 15.5092 73.125 17.0625C73.125 18.6158 74.3842 19.875 75.9375 19.875Z",
    fill: "#CAD0D8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9375 18.1875C76.5588 18.1875 77.0625 17.6838 77.0625 17.0625C77.0625 16.4412 76.5588 15.9375 75.9375 15.9375C75.3162 15.9375 74.8125 16.4412 74.8125 17.0625C74.8125 17.6838 75.3162 18.1875 75.9375 18.1875Z",
    fill: "#F4F6F8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.438 71.625C153.991 71.625 155.25 70.3658 155.25 68.8125C155.25 67.2592 153.991 66 152.438 66C150.884 66 149.625 67.2592 149.625 68.8125C149.625 70.3658 150.884 71.625 152.438 71.625Z",
    fill: "#CAD0D8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.438 69.9375C153.059 69.9375 153.562 69.4338 153.562 68.8125C153.562 68.1912 153.059 67.6875 152.438 67.6875C151.816 67.6875 151.312 68.1912 151.312 68.8125C151.312 69.4338 151.816 69.9375 152.438 69.9375Z",
    fill: "#F4F6F8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8125 90.75C58.3658 90.75 59.625 89.4908 59.625 87.9375C59.625 86.3842 58.3658 85.125 56.8125 85.125C55.2592 85.125 54 86.3842 54 87.9375C54 89.4908 55.2592 90.75 56.8125 90.75Z",
    fill: "#CAD0D8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8125 89.0625C57.4338 89.0625 57.9375 88.5588 57.9375 87.9375C57.9375 87.3162 57.4338 86.8125 56.8125 86.8125C56.1912 86.8125 55.6875 87.3162 55.6875 87.9375C55.6875 88.5588 56.1912 89.0625 56.8125 89.0625Z",
    fill: "#F4F6F8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4375 64.875C27.9908 64.875 29.25 63.6158 29.25 62.0625C29.25 60.5092 27.9908 59.25 26.4375 59.25C24.8842 59.25 23.625 60.5092 23.625 62.0625C23.625 63.6158 24.8842 64.875 26.4375 64.875Z",
    fill: "#CAD0D8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4375 63.1875C27.0588 63.1875 27.5625 62.6838 27.5625 62.0625C27.5625 61.4412 27.0588 60.9375 26.4375 60.9375C25.8162 60.9375 25.3125 61.4412 25.3125 62.0625C25.3125 62.6838 25.8162 63.1875 26.4375 63.1875Z",
    fill: "#F4F6F8"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.28 46.875L120.424 47.415C116.615 47.838 113.065 49.5458 110.356 52.2548L88.29 74.3205L97.83 83.865L119.9 61.7992C122.611 59.0902 124.317 55.5397 124.74 51.7305L125.28 46.875Z",
    stroke: "#464646",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.29 74.3205L80.1405 71.6025C79.2563 71.31 78.7793 70.356 79.0718 69.4717C79.155 69.222 79.2945 68.997 79.4813 68.8102L80.0033 68.2882C83.619 64.6725 88.9673 63.408 93.8183 65.0257L96.642 65.9662L88.29 74.3205Z",
    stroke: "#464646",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.29 74.3205L80.1405 71.6025C79.2563 71.31 78.7793 70.356 79.0718 69.4717C79.155 69.222 79.2945 68.997 79.4813 68.8102L80.0033 68.2882C83.619 64.6725 88.9673 63.408 93.8183 65.0257L96.642 65.9662L88.29 74.3205Z",
    fill: "#74B0F4",
    stroke: "#464646",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.83 83.865L100.548 92.0145C100.841 92.8987 101.795 93.3757 102.679 93.0832C102.929 93 103.156 92.8605 103.34 92.6737L103.865 92.1517C107.48 88.536 108.743 83.1877 107.125 78.3367L106.189 75.5242L97.83 83.865Z",
    stroke: "#464646",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.83 83.865L100.548 92.0145C100.841 92.8987 101.795 93.3757 102.679 93.0832C102.929 93 103.156 92.8605 103.34 92.6737L103.865 92.1517C107.48 88.536 108.743 83.1877 107.125 78.3367L106.189 75.5242L97.83 83.865Z",
    fill: "#74B0F4",
    stroke: "#464646",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1578 85.0598C92.16 86.403 91.6267 87.69 90.675 88.6395C88.6995 90.615 78.75 93.4118 78.75 93.4118C78.75 93.4118 81.5468 83.4555 83.5223 81.4868C84.3907 80.616 85.545 80.094 86.7712 80.013L92.1578 85.0598Z",
    fill: "#F18686",
    stroke: "#464646",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
});
export default SvgRocket;
export const raw = __webpack_public_path__ + "static/media/rocket.afba9056b02df0e90c0a45d50cf68c92.svg";